import React from 'react';
import { Button } from '@carnica/ui-kit';
import classNames from 'classnames/bind';

import { IButton } from 'pages/MainPage/blocks/TariffCardBlock/types';
import { Metric } from 'pages/MainPage/metric';

import { usePrepareConnectButton } from './hooks/usePrepareConnectButton';
import { useConnectBasket } from './hooks/useConnectBasket';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/** Кнопка подключения */
export const ConnectButton: React.FC<
  IButton & { isLarge?: boolean; tariffLabel: string | undefined }
> = ({ basketPayload, text, tariffLabel, isLarge = false }) => {
  const { isLoading, onConnect } = useConnectBasket({ basketPayload });
  const metricData = usePrepareConnectButton(text, tariffLabel);

  return (
    <div className={cx('button', { large: isLarge })}>
      <Metric data={metricData} events={{ tariffCardMetric: ['handleConnectClick'] }} mode="click">
        <Button
          loading={isLoading}
          onClick={onConnect}
          size={isLarge ? 'l' : 'm'}
          width={isLarge ? 'full' : 'default'}
        >
          {text}
        </Button>
      </Metric>
    </div>
  );
};
